import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import { Authenticated } from "./components/Authentificated";
import { Loading } from "./components/Loading";
import { Unauthenticated } from "./components/Unauthenticated";
import { useAuth } from "@nikolausturnier/shared/src/hooks";
import { Provider } from "react-redux";
import { store } from "./app/store";
import CssBaseline from "@mui/material/CssBaseline";
import { getTheme } from "@nikolausturnier/shared/src/theme";

export const App = () => {
  const { user } = useAuth();
  const theme = getTheme(user);

  if (user !== undefined) {
    return (
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            {user ? <Authenticated user={user} /> : <Unauthenticated />}
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    );
  } else {
    return <Loading />;
  }
};
